
import ItemDetails from '@/components/Items/ItemDetails.vue'
import Vue from 'vue'
export default Vue.extend({
  components: { "item-details": ItemDetails }, 

})
